import React from "react";

// CustomInput Component
export const CustomInput = ({
    type = "text",
    id = "input-rounded",
    label = "",
    placeholder = "Placeholder",
    className = "form-control",
    onChange,
    value,
    name,
    disabled = false,
    wrapperClassName = "",
    ...props
}) => {
    return (
        <div className="">
            <div className={wrapperClassName}>
                {label && (
                    <label htmlFor={id} className="form-label">
                        {label}
                    </label>
                )}
                {type === "textarea" ? (
                    <textarea
                        className={`${className} flex-1`}
                        id={id}
                        placeholder={placeholder}
                        onChange={onChange}
                        value={value}
                        name={name}
                        disabled={disabled}
                        rows={props.rows || 3}
                        {...props}
                        required
                    />
                ) : (
                    <input
                        type={type}
                        className={`${className} flex-1`}
                        id={id}
                        placeholder={placeholder}
                        onChange={onChange}
                        value={value}
                        name={name}
                        disabled={disabled}
                        onWheel={(e) => e.target.blur()}
                        {...props}
                        required
                    />
                )}
            </div>
        </div>
    );
};
